import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_category_donut_template extends vnTemplate {

    protected buildViewModel(): any {
        let _this = this;
        return {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            categoryName: ko.observable(""),
            valueName: ko.observable(""),
            cssWidth: ko.observable("100%"),
            cssHeight: ko.observable("300px"),
            xAxisRotation: ko.observable(0),
            xAxisFontSize: ko.observable(8),
            seriesTooltipFormat: ko.observable("{name}: [bold]{valueY}[/]"),
            show: ko.observable(true),
            yaxis: ko.observableArray([]),
            ranges: ko.observableArray([]),
        };
    }

    protected getMainElementClasses(): Array<string> {
        return ["graph"];
    }

    protected getTemplateHtml(): string {
        return `<div data-bind="attr: {id: idChart}, style: {width: cssWidth, height: cssHeight, display: (show() == true) ? 'block': 'none' }"></div>`;
    }

    protected getTemplateName(): string {
        return "amCharts_v4_pie_chart";
    }

    public setXAxisRotation(rotation: number): void {
        this.getTemplateViewModel().xAxisRotation(rotation);
    }


    public setXAxisFontSize(rotation: number): void {
        this.getTemplateViewModel().xAxisFontSize(rotation);
    }

    public setSeriesTooltipFormat(tooltipFormat: string): void {
        this.getTemplateViewModel().seriesTooltipFormat(tooltipFormat);
    }

    public setCategoryName(categoryName) {
        this.getTemplateViewModel().categoryName(categoryName);
    }

    public setValueName(valueName) {
        this.getTemplateViewModel().valueName(valueName);
    }

    public setYaxis(axis) {
        this.getTemplateViewModel().yaxis(axis);
    }

    public setRanges(ranges) {
        this.getTemplateViewModel().ranges(ranges);
    }

    public show(): void {
        this.getTemplateViewModel().show(true);
    }

    public hide(): void {
        this.getTemplateViewModel().show(false);
    }

    public drawChart(chartData) {
        let _this = this;
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.PieChart);

        chart.legend = new am4charts.Legend();

// Add data
        chart.data = chartData;

// Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = this.getTemplateViewModel().valueName();
        pieSeries.dataFields.category = this.getTemplateViewModel().categoryName();

// Let's cut a hole in our Pie chart the size of 40% the radius
        chart.innerRadius = am4core.percent(60);

// Disable ticks and labels
        pieSeries.labels.template.disabled = true;
        pieSeries.ticks.template.disabled = true;

// Disable tooltips
//         pieSeries.slices.template.tooltipText = "";
        pieSeries.slices.template.propertyFields.fill = "color";

        chart.logo.disabled = true;
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_category_donut_template.ts